import { useTranslation } from '@rhino-project/core/i18n';
import {
  BaseAuthedPage,
  CellString,
  MaxWidth,
  ModelFilters,
  ModelIndexActionCreateModal,
  ModelIndexSimple,
  ModelIndexTable,
  ModelPager,
  ModelSearch
} from '@rhino-project/ui-heroui';
import { useFeature } from '@rhino-project/core/hooks';

const PlayersPage = () => {
  const { t } = useTranslation();

  // Adding players is gated on player_management, which either base package
  // grants (backend enforces the same via AdminPlayerPolicy).
  const canAddPlayer = useFeature('player_management');

  return (
    <BaseAuthedPage>
      <MaxWidth>
        <ModelIndexSimple analyticsSurface="index_page" model="player" syncUrl>
          <div className="flex flex-col gap-3">
            <ModelSearch />
            <ModelFilters
              paths={[
                'player_positions.position::tree_subtree',
                'dob_year',
                'grad_year',
                'rosters.team_season.season',
                'rosters.team_season.team',
                'rosters.roster_status'
              ]}
            />
            <div className="flex flex-row items-center gap-3">
              <div className="ml-auto">
                <ModelPager />
              </div>
            </div>
            <hr />
            {canAddPlayer && <ModelIndexActionCreateModal />}
            <ModelIndexTable
              paths={[
                'last_name',
                'first_name',
                'dob_year',
                'grad_year',
                <CellString
                  key="external_linked_teams.0.display_name"
                  path="external_linked_teams.0.display_name"
                  header={t('frontend.messages.most_recent_team')}
                />,
                'number',
                'positions',
                'quick_rating'
              ]}
            />
          </div>
        </ModelIndexSimple>
      </MaxWidth>
    </BaseAuthedPage>
  );
};

export default PlayersPage;
